/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var ListToken = /** @class */ (function () {
    function ListToken() {
    }
    ListToken.Each = "#each";
    ListToken.ClosingEach = "/each";
    ListToken.ItemBinding = ".$";
    return ListToken;
}());
export { ListToken };
;
